module.exports = __webpack_public_path__ + "img/gratiaimage1.6f892bc0.jpg";